export default "__VITE_ASSET__BaDSx39z__"